import {
    GET_EMISIONES_PAGOS,
    GET_RESUMEN_COMPANIA_EMISION,
    GET_DETALLE_PAGOS_EMISION,
    GET_ESTADO_INFORME_EMISION,
    POST_REGENERAR_INFORME_EMISION
} from '../types';

export default function consultaEmisionPagosReducer(state = {}, action) {
    if (action.error) return state

    switch (action.type) {
        case GET_EMISIONES_PAGOS:
            return { ...state, emisiones: action.payload }
        case GET_RESUMEN_COMPANIA_EMISION:
            return { ...state, resumenCompania: action.payload }
        case GET_DETALLE_PAGOS_EMISION:
            return { ...state, detallePagos: action.payload }
        case GET_ESTADO_INFORME_EMISION:
            return { ...state, estadoInforme: action.payload }
        case POST_REGENERAR_INFORME_EMISION:
            return { ...state, informeRegenerado: action.payload }
        default:
            return state
    }
}
